import {LitElement, html, nothing} from "lit";
import {customElement, property, state} from "lit/decorators.js";
import {classMap} from "lit/directives/class-map.js";

import {toastStyles} from "./Toast.styles.js";
import {renderPowerNotesLogo} from "../powerNotesLogo.js";

export type ToastType = "error" | "info" | "share" | "success" | "warning";

export const ANIMATION_DELAY = 500; // show/hide animation
const DISMISS_DELAY =  5000;

@customElement("pn-toast")
export class Toast extends LitElement {
	static styles = [toastStyles];

	@property() autoDismiss = true;
	@property() content = "";
	@property() showLogo = true;
	@property() title = "";
	@property() type: ToastType = "success";

	@state() isOpen = false;

	timeout: NodeJS.Timeout | null = null;

	/**
	 * TODO:
	 * - closable (X button)
	 * - make it compatible for future use with web app/ext banners
	 * - clearing old toasts vs creating a stack of them visually on the screen
	 */

	firstUpdated(): void {
		setTimeout(() => this.open(), ANIMATION_DELAY);
	}

	open = () => {
		this.isOpen = true;

		if (this.autoDismiss) {
			if (this.timeout)
				clearTimeout(this.timeout);

			this.timeout = setTimeout(() => this.dismiss(), DISMISS_DELAY);
		}
	};

	dismiss = () => {
		if (this.timeout)
			clearTimeout(this.timeout);

		this.isOpen = false;

		// For now, just remove from DOM after letting the animation complete
		setTimeout(() => this.remove(), ANIMATION_DELAY);
	};

	renderTitle() {
		if (!this.title || this.title === "")
			return nothing;

		return html`<strong>${this.title}&nbsp;</strong>`;
	}

	render() {
		return html`
			<div
				class=${classMap({
					"container": true,
					// TODO: use a var (if this component is used for banners later)
					"fit-width": true,
					"open":      this.isOpen,
					[this.type]: true
				})}
				id=${this.id}
				role="status"
			>
				${this.showLogo ? renderPowerNotesLogo("pn-logo") : nothing}
				<div class="content">${this.renderTitle()}${this.content}</div>
			</div>
		`;
	}
};

declare global {
	interface HTMLElementTagNameMap {
		"pn-toast": Toast;
	}
}
